import { excludeProducersArray, renameProducerForBetshistory } from 'shared/utils/slotshistory'

import { Providers } from 'modules/SlotsRoot/types/configuration'
import { IProducer, IProducersList } from 'modules/SlotsRoot/types/interfaces/Api'
import { DigitainSlotToken, DigitainSlotTokenDTO } from 'modules/SlotsRoot/types/interfaces/Slots/DigitainSlot'
import { IGetGameListDTO, ISlotDTO } from 'modules/SlotsRoot/types/interfaces/Slots/GameCatalog'
import {
  INewGamesDTO,
  ISlotViewItem,
  ITopSlotsDTO,
  IWagerGamesDTO,
} from 'modules/SlotsRoot/types/interfaces/Slots/Slots'
import { getAdditionalIntegrationGameId } from 'modules/SlotsRoot/utils/helpers/helpers'
import { getGameCatalogImage } from 'modules/SlotsRoot/utils/images'

import { IConvertGameList, ISlotConverter } from '../../types/converter'
import { getTabLive } from '../Softswiss/SoftwissUtils'
import {
  blackListGames,
  getGameCatalogTab,
  getGameType,
  getIsFreeSpinAvailable,
  getSlotProviderName,
  keltGamesBlackListProviders,
  providerReplacingNames,
  providersWhiteList,
} from './GameCatalogUtils'
import { getPureGameId, uniqGameId } from './uniqGameId'

class GameCatalogConverter implements ISlotConverter {
  convertGameList = ({ data, platform }: IConvertGameList<IGetGameListDTO>): ISlotViewItem[] =>
    data.games
      .map((item: ISlotDTO) => {
        const provider: string = getSlotProviderName(item)
        const gameId = uniqGameId(item.integration, provider, item.game_id)

        return {
          id: String(item.id),
          gameId,
          description: item.description,
          gameName: item.name,
          tab: getGameCatalogTab(gameId, item.drops_and_wins),
          tabLive: getTabLive(item.game_id),
          provider,
          imageUrl: getGameCatalogImage({
            slotId: item.game_id,
            imageUrl: item.image,
            imageDesktop: item.image_desktop,
            provider: item.integration,
            platform,
          }),
          routeProvider: item.integration,
          additionalData: {
            system: item.slug.split('/')?.[0],
          },
          additionalIntegrationGameId: getAdditionalIntegrationGameId(item.integration, item),

          // hasFreeSpins: getIsFreeSpinAvailable(provider, item.has_freespins), // TODO: пофиксить с бэком
          hasFreeSpins: false,
          ...getGameType(item),
        }
      })

      .filter(t => {
        switch (t.routeProvider) {
          case Providers.DIGITAIN:
            return true
          case Providers.KELT_GAMES:
            return !keltGamesBlackListProviders.includes(t.provider)
          default:
            return (
              providersWhiteList.includes(t.provider) &&
              !(blackListGames.includes(t.gameId) || blackListGames.includes(getPureGameId(t.gameId)))
            )
        }
      })

  convertGameUrl = ({ data }: { data: string | { url: string } }) => {
    const convertedData = typeof data === 'string' ? data : data?.url
    if (convertedData?.toString().trim().startsWith('<')) {
      const blob = new Blob([convertedData], { type: 'text/html' })
      return URL.createObjectURL(blob)
    }
    return convertedData
  }

  convertGameUrlPragmatic = ({ data }: { data: { gameURL: string } }) => data.gameURL

  // eslint-disable-next-line camelcase
  convertGameUrlKeltgames = ({ data }: { data: { launch_url: string } }) => data.launch_url

  convertProducers = (data: IProducersList): IProducer[] => {
    const producers = data.producers
      .filter(
        item => !item?.integrations?.includes('89fa86ca') && !excludeProducersArray.includes(item.name) && item.active,
      )
      .map(item => ({
        ...item,
        name: renameProducerForBetshistory[item.name] || item.name,
      }))

    return producers
  }

  // eslint-disable-next-line camelcase
  convertGameUrlBcraft = ({ data }: { data: { game_url: string } }) => data.game_url

  convertTopSlots = (data: ITopSlotsDTO): string[] => data.games || []

  convertNewGames = (data: INewGamesDTO): string[] => data.games || []

  convertWagerSlots = (data: IWagerGamesDTO): string[] => data.games

  convertDigitainSlotToken(data: DigitainSlotTokenDTO): DigitainSlotToken {
    return data.token
  }
}

export default GameCatalogConverter
